'use strict';

import ApiEndpoint from './api_endpoint';

export default class ListDistribution extends ApiEndpoint {
  execute(callback = undefined, session = undefined, questionnaireKey) {
    if (session === undefined) {
      return this.session.get('/questionnaire/' + questionnaireKey + '/results/distribution', undefined, callback);
    }
    return session.get('/questionnaire/' + questionnaireKey + '/results/distribution', undefined, callback);
  }
}
